'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import Networks from 'ads-account-connection/lib/Networks';
import NetworkIcon from 'ads-account-connection/components/NetworkIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIFormControl from 'UIComponents/form/UIFormControl';

const FBPixelSelectTooltip = ({
  alreadyInstalled,
  noPixelId
}) => {
  if (alreadyInstalled) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.pixelAlreadyInstalled"
    });
  }

  if (noPixelId) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.noPixelId"
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.alreadyInstalled"
  });
};

const TooltipItem = ({
  children,
  option
}) => {
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      title: option.tooltip,
      disabled: !option.disabled,
      children: children
    })
  });
};

const FacebookPixelSelect = ({
  adAccounts,
  facebookPixels,
  onPixelChange,
  disableInstalled,
  trackEvent,
  defaultSelection,
  selectedPixel,
  showErrors
}) => {
  const getPixelText = (pixel, adAccount) => {
    if (pixel.installed && !pixel.accessible) {
      // If an installed pixel has become inaccessible, the name isn't available,
      // so just use the id and inform the user about a permissions issue.
      return I18n.text('ADS_ACCOUNT_CONNECTION.audiences.pixels.installedPixelOption', {
        pixelId: pixel.id
      });
    }

    return `${pixel.name} (${adAccount.accountId})`;
  };

  const getPixelUniqueId = pixel => `${pixel.adNetwork},${pixel.accountId},${pixel.id}`;

  const getOptions = () => {
    if (!facebookPixels) {
      return [];
    }

    return facebookPixels.map(pixel => {
      const pixelAdAccount = adAccounts.find(adAccount => adAccount.network === pixel.adNetwork && adAccount.accountId === pixel.accountId);
      return {
        text: getPixelText(pixel, pixelAdAccount),
        avatar: /*#__PURE__*/_jsx(NetworkIcon, {
          network: Networks.FACEBOOK
        }),
        value: getPixelUniqueId(pixel),
        pixel,
        disabled: !pixel.accessible || disableInstalled && pixel.installed || !pixel.id,
        trackEvent,
        tooltip: /*#__PURE__*/_jsx(FBPixelSelectTooltip, {
          alreadyInstalled: disableInstalled && pixel.installed,
          noPixelId: !pixel.id
        })
      };
    }).toArray();
  };

  const handleChange = e => {
    const [network, adAccountId, pixelId] = e.target.value.split(',');
    const pixel = facebookPixels.find(fbPixel => fbPixel.adNetwork === network && fbPixel.accountId === adAccountId && fbPixel.id === pixelId);
    onPixelChange(pixel);
  };

  const showValidationError = showErrors && !selectedPixel;
  return /*#__PURE__*/_jsx(UIFormControl, {
    error: showValidationError,
    validationMessage: showValidationError ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.validationError.selectedPixel",
      "data-test-id": "select-pixel-validation-error"
    }) : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      onChange: handleChange,
      options: getOptions(),
      placeholder: I18n.text('ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.selectPixelPlaceholder'),
      className: "fb-pixel-select",
      defaultValue: defaultSelection ? getPixelUniqueId(defaultSelection) : null,
      disabled: !!defaultSelection,
      itemComponent: TooltipItem
    })
  });
};

export default FacebookPixelSelect;